<div class="signIn-modal">
  <div class="heading-title">
      {{ data?.message }}
  </div>
      <!-- <mat-dialog-content> -->
      <form [formGroup]="loginForm" class="assessment_pt-20">

        <div class="form-group 111 assessment_mb-0">
          <ngx-intl-tel-input [cssClass]="'intelTel font-w6 form-control'"
          [preferredCountries]="[CountryISO.India]" [enableAutoCountrySelect]="false"
              [enablePlaceholder]="false" [searchCountryFlag]="true"
              [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
              [selectedCountryISO]="CountryISO.India" maxLength="10" [phoneValidation]="true" [separateDialCode]="true"
              name="phone" formControlName="phone" (keypress)="enterKey($event)" 
              (keyup)="doSearch($event)" readonly></ngx-intl-tel-input>
        </div>
        <div class="d-flex justify-content-center IL_sc-click font-weight-bold">
          <span class="assessment_mt-10" *ngIf="!data?.HideSCMsg">Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">click here</span>  to login</span>
        </div>
          <!-- <div class="btn-next"> -->
              <button class="btn btn-primary btn-block assessment_mt-25" [disabled]="!customValid || !mobileNumberValid"  type="button" (click)="doSearch($event);passwordLogin()">NEXT</button>
          <!-- </div> -->
      </form>
      <!-- </mat-dialog-content> -->
  </div>
